/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trip_Picker_Attached_To_ExistingInputs */

const vi_trip_picker_attached_to_existing = /** @type {(inputs: Trip_Picker_Attached_To_ExistingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn này sẽ được gắn vào chuyến hiện tại`)
};

/**

* @param {Trip_Picker_Attached_To_ExistingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const trip_picker_attached_to_existing = /** @type {((inputs?: Trip_Picker_Attached_To_ExistingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trip_Picker_Attached_To_ExistingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_trip_picker_attached_to_existing(inputs)
});